import API from './api';

// Get current version requirements
export const getVersionRequirements = async () => {
  try {
    const response = await API.get('/version/requirements');
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Update version requirements
export const updateVersionRequirements = async (versionData) => {
  try {
    const response = await API.put('/version/requirements', versionData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get version update history
export const getVersionHistory = async () => {
  try {
    const response = await API.get('/version/history');
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Check app version (for testing)
export const checkAppVersion = async (currentVersion, platform) => {
  try {
    const response = await API.post('/version/check', {
      currentVersion,
      platform
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Delete a specific version
export const deleteVersion = async (platform, version) => {
  try {
    const response = await API.delete(`/version/${platform}/${version}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Update an existing version
export const updateVersion = async (platform, version, updateMessage, forceUpdate) => {
  try {
    const response = await API.put('/versionedit', {
      platform,
      version,
      updateMessage,
      forceUpdate
    });
    return response.data;
  } catch (error) {
    console.error('Error updating version:', error);
    throw error;
  }
};
